<template>
  <div id="app">
    <Nav></Nav>
    <router-view class="main-content"></router-view>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Nav from './components/Nav';
import Bottom from './components/Bottom';
export default {
  name: 'app',
  components: {
    Nav,
    Bottom,
  }
}
</script>

<style lang="less">
@import url('./assets/style/common.less');
@import url('./assets/style/colors.less');
html,body{
  margin:0;
  padding:0;
  min-height: 100%;
  background-color: rgb(22,19,88);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgb(22,19,88);
  text-align: center;
  color: #2c3e50;
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background-repeat: round;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1 0 auto;
  width: 100%;
}
.el-submenu__title{
  height: 50px;
}
@media screen and (max-width: 992px) {
  html,body{
    width: 100%;
    height: 100%;
  }
  #app {
    // height: 100%;
    background-repeat: initial;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue